import React from "react"
import Logo from "../assetts/logo"

type Props = {
  children?: React.ReactNode
  header?: React.ReactNode
}

export default function ({ children, header }: Props) {
  return (
    <div className="bg-stone-light">
      <div className="  max-w-[1352px] mx-auto">
        <header>
          <div className="flex items-center pr-4 ">
            <nav>
              <a href="/" aria-label="Flyp Logo Home">
                <Logo />
              </a>
            </nav>
            {header}
          </div>
        </header>
        <main className=" h-px relative min-h-page">{children}</main>
      </div>
    </div>
  )
}
